// Generated by scripts/generate-build-env.js — do not edit or commit.
export const buildEnv: { [key: string]: string | undefined } = {
  PRODUCTION: "false",
  API_URL: "https://api.dev2.energywelldev.com:443/",
  PRODUCT_URL: "https://api.dev2.energywelldev.com:443/",
  IMAGE_URL: "https://energywell.corpadmin.directscale.com/CMS/Images/Inventory",
  CLIENT_EXTENSION_API: "https://energywell.clientextension.directscalestage.com/",
};
